import React from 'react';
import { Column } from 'app/design/primitives/box';
import type { NeighbourTab, ProfileListingResults } from './shared';
import { NeighbourOffers } from './neighbour-offers';
import { NeighbourRequests } from './neighbour-requests';

export function NeighbourListings({
  isLargeUI,
  offers,
  requests,
  searchQuery,
  setSearchQuery,
  tab,
}: {
  isLargeUI: boolean;
  offers: ProfileListingResults;
  requests: ProfileListingResults;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  tab: NeighbourTab;
}) {
  return (
    <Column paddingTop="spacing.general.x4">
      {tab === 'requests' ? (
        <NeighbourRequests
          isLargeUI={isLargeUI}
          results={requests}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      ) : (
        <NeighbourOffers
          isLargeUI={isLargeUI}
          results={offers}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      )}
    </Column>
  );
}
